import { render, staticRenderFns } from "./TheHeaderBS46.vue?vue&type=template&id=73b61bce&scoped=true"
import script from "./TheHeaderBS46.vue?vue&type=script&lang=js"
export * from "./TheHeaderBS46.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderBS46.vue?vue&type=style&index=0&id=73b61bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b61bce",
  null
  
)

export default component.exports